export default __webpack_public_path__ + "static/media/7.a216e8c8.png";